const algoliasearch = require('algoliasearch');
const client = algoliasearch('10FBZEOMKQ', '0afc88e7f192c55526f20260969bad41');


export default () => ({
	mainNav: false,
	subNav: false,
	searching: false,
	searchActive: false,
	searchQuery: '',
	searchResults: [],
	searchResultsTotal: 0,
	isResultsOpen: false,
	isHits: false,
	searchAlgolia(e) {
		this.searchActive = true;
		this.searching = true;
		document.body.style.overflow = 'hidden';
		e.target.value = '';
		const queries = [
			{
				indexName: 'pages',
				query: this.searchQuery,
			},
			{
				indexName: 'projects',
				query: this.searchQuery,
			},
			{
				indexName: 'products',
				query: this.searchQuery,
			},
			{
				indexName: 'people',
				query: this.searchQuery,
			}
		];
		client.multipleQueries(queries).then((res) => {
			this.searching = false;
			this.searchResultsTotal = 0;
			// for each res.results push hits to searchResults
			this.searchResults = [];
			res.results.forEach((result) => {
				let res = {};
				res.indexName = result.index;
				res.hits = result.hits;
				res.totalHits = result.nbHits;
				this.searchResultsTotal += result.nbHits;
				this.searchResults.push(res);
			});

			// manually sort this.searchResults in this order = products, projects, people, pages
			let sortedResults = [];
			this.searchResults.forEach((result) => {
				if (result.indexName == 'products') {
					sortedResults[0] = result;
				}
				if (result.indexName == 'projects') {
					sortedResults[1] = result;
				}
				if (result.indexName == 'people') {
					sortedResults[2] = result;
				}
				if (result.indexName == 'pages') {
					sortedResults[3] = result;
				}
			});
			this.searchResults = sortedResults;
			this.isResultsOpen = true;
			if (this.searchResults[0].hits.length > 0 || this.searchResults[1].hits.length > 0 || this.searchResults[2].hits.length > 0) {
				this.isHits = true;
			}
		}
		);
	},
	resetSearch() {
		this.searchActive = false;
		this.searchQuery = '';
		this.searchResults = [];
		this.searchResultsTotal = 0;
		this.isResultsOpen = false;
		this.isHits = false;
		document.body.style.overflow = 'auto';
	},
	exitSearch() {
		this.resetSearch()
	},
	toggleMainNav: async function() {
		// console.log('toggled main nav')
		this.mainNav = !this.mainNav
		this.setOverscroll()
	},
	toggleANav: async function (name = false) {
		// console.log('toggle a nav')
		if (name !== false && name == this.mainNav) {
			this.mainNav = true // we just leave main nav open in default state
		} else {
			this.mainNav = name
		}
		this.setOverscroll()
	},
	closeNav: async function(navToClose) {
		// console.log('closed a nav')
		this[navToClose] = false;
		this.setOverscroll()
	},
	setNavOpen: async function(navToOpen, navValue) {
		// console.log('set a nav open')
		this[navToOpen] = navValue;
		this.setOverscroll()
	},
	setOverscroll: async function() {
		console.log('setting overscroll')
		if (this.mainNav !== false) {
			document.documentElement.classList.add('no-scroll')
		} else {
			document.documentElement.classList.remove('no-scroll')
		}
	}
})
